import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-standard-details',
  templateUrl: './standard-details.component.html',
  styleUrl: './standard-details.component.scss'
})
export class StandardDetailsComponent {
  constructor(private location: Location){}
  goBackToPrevPage(){
    this.location.back();
  }
}
